import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { CheckDuplicate } from 'components/CheckDuplicate';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const UsersEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		name: yup.string().required().label("Name"),
		phone: yup.string().required().label("Phone"),
		profile_photo: yup.string().nullable().label("Profile Photo"),
		roleid: yup.string().nullable().label("Roleid")
	});
	// form default values
	const formDefaultValues = {
		name: '', 
		phone: '', 
		profile_photo: '', 
		roleid: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/users`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="UsersEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Editar User"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        Name *
                                        <div> 
                                            <CheckDuplicate value={formik.values.name} apiPath="components_data/users_name_exist">
                                            { (checker) => 
                                            <>
                                            <InputText name="name" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.name}   label="Name" type="text" placeholder="Entrar Name"        className={inputClassName(formik?.errors?.name)} />
                                            <ErrorMessage name="name" component="span" className="p-error" />
                                            {(!checker.loading && checker.exist) && <small className="p-error">Não disponível</small>}
                                            {checker.loading && <small className="text-500">Checking...</small> }
                                            </>
                                            }
                                            </CheckDuplicate>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        Phone *
                                        <div> 
                                            <InputText name="phone"  onChange={formik.handleChange}  value={formik.values.phone}   label="Phone" type="text" placeholder="Entrar Phone"        className={inputClassName(formik?.errors?.phone)} />
                                            <ErrorMessage name="phone" component="span" className="p-error" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        Profile Photo 
                                        <div> 
                                            <div className={inputClassName(formik?.errors?.profile_photo)}>
                                                <Uploader name="profile_photo" showUploadedFiles value={formik.values.profile_photo} uploadPath="fileuploader/upload/profile_photo" onChange={(paths) => formik.setFieldValue('profile_photo', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Escolha arquivos ou solte-os aqui" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                            </div>
                                            <ErrorMessage name="profile_photo" component="span" className="p-error" />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        Roleid 
                                        <div> 
                                            <DataSource   apiPath="components_data/roleid_option_list"  >
                                                {
                                                ({ response }) => 
                                                <>
                                                <Dropdown  name="roleid"     optionLabel="label" optionValue="value" value={formik.values.roleid} onChange={formik.handleChange} options={response} label="Roleid"  placeholder="Selecione um valor ..."  className={inputClassName(formik?.errors?.roleid)}   />
                                                <ErrorMessage name="roleid" component="span" className="p-error" />
                                                </>
                                                }
                                            </DataSource>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Atualizar" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
UsersEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'users',
	apiPath: 'users/edit',
	routeName: 'usersedit',
	submitButtonLabel: "Atualizar",
	formValidationError: "O formulário é inválido",
	formValidationMsg: "Por favor, preencha o formulário",
	msgTitle: "Atualizar registro",
	msgAfterSave: "Registro atualizado com sucesso",
	msgBeforeSave: "Deseja Salvar os Dados Agora?",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default UsersEditPage;
